module.exports = require('./lib/react-emojione');
